// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoriesPicker_root__8egCL","dropdown":"CategoriesPicker_dropdown__1UXva","description":"CategoriesPicker_description__3j1sZ"};